import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import DiaryList from "./pages/DiaryList";
import DiaryDetail from "./pages/DiaryDetail";
import WriteDiary from "./pages/WriteDiary";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/diarylist" element={<DiaryList />} />
      <Route path="/diarydetail/:id" element={<DiaryDetail />} />
      <Route path="/writediary" element={<WriteDiary />} />
    </Routes>
  );
}

export default App;
